import React, { useState } from 'react'
import { useNavigate, useLocation } from "react-router-dom";

import {
  Layout,
  Input,
  Row,
  Typography,
  Card,
  Select,
  Collapse,
  Form,
  DatePicker,
  Col,
  InputNumber,
  Divider,
  Button,
  Modal,
  List,
  Spin
} from "antd";
import { BOM } from "../../../../../../services/definedMethod";
import cnt from "../../../../../../services/definedConstant";
import MainLayout from '../../../../../../components/layouts/MainLayout';
import TopContent from '../../../../../../components/layouts/TopContent';
import { apiConfig, labelConfig, staticConfig } from "../../../../group.config";
import CustomButton from '../../../../../../components/custom/CustomButton';

const LoanScreenReports = () => {

  const navigate = useNavigate();
  const [form] = Form.useForm();
  const { state } = useLocation();
  const [isLoading, setIsLoading] = useState(false);

  function onCancel() {
    navigate("/detail-child-glim", { state: state });
  }
  return (

    <MainLayout isEnableRightSidebar={true} >
      {/* PART 1  IMPORT TOP CONTENT*/}
      <TopContent
        pageTitle={labelConfig.loanScreenReports}
        pageItems={staticConfig.loanScreenReportsBreadcrumbItems}
      />

      <Spin spinning={isLoading} size="large">
        <Card
          headStyle={{ borderBottomWidth: 0 }}
          style={{
            boxShadow: "0px 0px 30px 3px rgba(0,0,0,0.1)",
            borderRadius: 20,
          }}
        >
          <Form
            form={form}
            layout="vertical"
          // onFinish={handleAddressSave}
          >

            <Row >
              <Divider />

              <Row>
                <Col span={8} style={{ padding: "0px 8px" }}>
                  <Form.Item
                    label={labelConfig.transactionAmount}
                    name={"transactionAmount"}
                    rules={[
                      {
                        required: true,
                        message: BOM.CheckReqFld(labelConfig.transactionAmount),
                      },
                    ]}
                  >
                    <Select
                      placeholder={BOM.handlePlaceholderMsg(
                        labelConfig.transactionAmount,
                        "select"
                      )}
                      // options={countryIdData}
                      showSearch
                    />
                  </Form.Item>
                </Col>

                <Col span={8} style={{ padding: "0px 8px" }}>
                  <Form.Item
                    label={labelConfig.transactionDate}
                    name={"transactionDate"}
                    rules={[
                      {
                        required: true,
                        message: BOM.CheckReqFld(
                          labelConfig.transactionDate
                        ),
                      },
                    ]}
                  >
                    <Select
                      placeholder={BOM.handlePlaceholderMsg(
                        labelConfig.transactionDate,
                        "select"
                      )}
                      // options={addressTypeIdData}
                      showSearch
                    />
                  </Form.Item>
                </Col>
                <Col span={8} style={{ padding: "0px 8px" }}>
                  <Form.Item
                    label={labelConfig.principal}
                    name={"principal"}

                  >
                    <Input
                      placeholder={BOM.handlePlaceholderMsg(
                        labelConfig.principal
                      )}
                    />
                  </Form.Item>
                </Col>

                <Col span={8} style={{ padding: "0px 8px" }}>
                  <Form.Item
                    label={labelConfig.interestAmount}
                    name={"interestAmount"}

                  >
                    <Input
                      placeholder={BOM.handlePlaceholderMsg(
                        labelConfig.interestAmount
                      )}
                    />
                  </Form.Item>
                </Col>


                <Col span={8} style={{ padding: "0px 8px" }}>
                  <Form.Item
                    label={labelConfig.paymentTypes}
                    name={"paymentTypes"}
                    rules={[
                      {
                        required: true,
                        message: BOM.CheckReqFld(
                          labelConfig.paymentTypes
                        ),
                      },
                    ]}
                  >
                    <Select
                      placeholder={BOM.handlePlaceholderMsg(
                        labelConfig.paymentTypes,
                        "select"
                      )}
                      // options={stateProvinceIdData}
                      showSearch
                    />
                  </Form.Item>
                </Col>
              </Row>

            </Row>

            <Row>
              <Divider />
              <CustomButton
                content="Submit"
                style={{
                  width: "10%",
                  marginLeft: "auto",
                  boxShadow: "0px 0px 10px 5px rgba(0,0,0,0.1)",
                }}
                htmlType="submit"
                backgroundColor="#92428B"
                colorText="white"
                hoverBackground="#AD4EA7"
              />

              <CustomButton
                content="Cancel"
                style={{
                  width: "10%",
                  marginLeft: "1%",
                  boxShadow: "0px 0px 10px 5px rgba(0,0,0,0.1)",
                }}
                backgroundColor="#fff"
                colorText="black"
                hoverBackground="#F5F5F5"
                onClick={onCancel}
              />
            </Row>
          </Form>

        </Card>
      </Spin>

    </MainLayout>
  )
}

export default LoanScreenReports